import styled from 'styled-components';

export const Card = styled.div`
    width: 300px;
    height: 377px;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.25), 0 2px 2px 0 rgba(0, 0, 0, 0.25);

    @media (max-width: 425px) {
        width: 260px;
    }

    @media (max-width: 320px) {
        width: 240px;
    }
`;

export const CardImageContainer = styled.div`
    height: 55%;
    width: 100%;

    //obrigatorio para funcionar o "fill" no nextjs image
    position: relative;
    display: block;
`;

export const InfoContainer = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 1;
`;

export const TextContainer = styled.div`
    height: calc(100% - 55%);
    padding: 20px;
    position: relative;

    display: flex;
    flex-direction: column;
`;

export const Destaque = styled.div`
    border: 1px solid;
    background-color: #fff;
    color: #30bcd5;
    margin-left: 20px;
    margin-top: 10px;
    padding: 8px;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    position: absolute;
`;

export const SuperDestaque = styled.div`
    border: 1px solid #30bcd5;
    background-color: #30bcd5;
    color: #fff;
    margin-left: 20px;
    margin-top: 10px;
    padding: 8px;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    position: absolute;
`;

export const FavoritoWrapper = styled.div`
    margin-top: 15px;
    margin-right: 22px;
    position: absolute;
    right: 0;
`;

export const Titulo = styled.h3`
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    color: #4a4a4a;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const Subtitulo = styled.div`
    font-size: 14px;
    color: #626363;
    margin-top: 18px;

    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const Preco = styled.div`
    font-size: 16px;
    font-weight: bold;

    text-transform: uppercase;
    color: #288394;

    align-self: flex-end;
    margin-top: auto;
`;
